import React, { Component } from 'react';
import './Products.css';
import EditBar from '../EditBar/EditBar';

class Products extends Component {
  toggleEditing(toggle) {
    if (this.props.onToggleEditing) {
      this.props.onToggleEditing(toggle);
    }
  }

  render() {
    const {
      sectionIndex,
      contentBlockIndex,
      removeContentBlock,
      skus
    } = this.props;

    return (
      <div className={`products edit-wrapper`}>
        <div>
          <strong>Products to display</strong>: {skus}
        </div>
        <EditBar
          toggleEditing={() => this.toggleEditing(true)}
          removeContentBlock={() =>
            removeContentBlock(sectionIndex, contentBlockIndex)
          }
        />
      </div>
    );
  }
}

export default Products;



// WEBPACK FOOTER //
// ./src/components/landingPage/Products/Products.js